import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid'
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CancelIcon from '@material-ui/icons/Cancel';
import Loaders from '../../../Components/Loader'
import Web3 from "web3";
var web3;
let accounts;
let finalAccount;
let mainAdd;
let mainABI;
let mainContract;
const today = new Date();

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: '#14bcfd',
    border: '0px solid #000',
    width: '100%',
    maxWidth: 750,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 'none',
    borderRadius: 10
  },
}));

const WithDrawList = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [usedateError, setdateError] = useState(false)
  const [useUnlockDate, setUnlockDate] = useState()
  const [useLoader, setLoader] = useState('none')

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDated = (val,type) => {
    setdateError(false)
    let value = val.target.value.toLowerCase();
    const result =new Date(value).getTime()
    const todayDate =new Date(today).getTime()
    if(todayDate > result){
      console.log('Wrong Time Selecteed')
      setdateError(true)
    }else{
      console.log('Right Time Selecteed')
      setdateError(false)
    }
    setUnlockDate((result/1000))
    console.log('New time: ' , result/1000)
  }

  useEffect(()=> {
    connectWallet();
  },[]);
  const connectWallet = () => {
    if(window.web3 !== undefined){
      web3 = new Web3(window.ethereum);
      mainAdd = '0x8D217DfC9FA1F7ab52fBAEfa9f09fb28Df6f664C'; 
      mainABI = [{"inputs":[{"internalType":"contract IUniFactory","name":"_uniswapFactory","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"lpToken","type":"address"},{"indexed":false,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lockDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"unlockDate","type":"uint256"}],"name":"onDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"lpToken","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"onWithdraw","type":"event"},{"inputs":[],"name":"gFees","outputs":[{"internalType":"uint256","name":"ethFee","type":"uint256"},{"internalType":"contract IERCBurn","name":"secondaryFeeToken","type":"address"},{"internalType":"uint256","name":"secondaryTokenFee","type":"uint256"},{"internalType":"uint256","name":"secondaryTokenDiscount","type":"uint256"},{"internalType":"uint256","name":"liquidityFee","type":"uint256"},{"internalType":"uint256","name":"referralPercent","type":"uint256"},{"internalType":"contract IERCBurn","name":"referralToken","type":"address"},{"internalType":"uint256","name":"referralHold","type":"uint256"},{"internalType":"uint256","name":"referralDiscount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getLockedTokenAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNumLockedTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"}],"name":"getNumLocksForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getUserLockForTokenAtIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getUserLockedTokenAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"getUserNumLockedTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_lpToken","type":"address"}],"name":"getUserNumLocksForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"getUserWhitelistStatus","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getWhitelistedUserAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getWhitelistedUsersLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"incrementLock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_unlock_date","type":"uint256"},{"internalType":"address payable","name":"_referral","type":"address"},{"internalType":"bool","name":"_fee_in_eth","type":"bool"},{"internalType":"address payable","name":"_withdrawer","type":"address"}],"name":"lockLPToken","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"migrate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_unlock_date","type":"uint256"}],"name":"relock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"_devaddr","type":"address"}],"name":"setDev","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_referralPercent","type":"uint256"},{"internalType":"uint256","name":"_referralDiscount","type":"uint256"},{"internalType":"uint256","name":"_ethFee","type":"uint256"},{"internalType":"uint256","name":"_secondaryTokenFee","type":"uint256"},{"internalType":"uint256","name":"_secondaryTokenDiscount","type":"uint256"},{"internalType":"uint256","name":"_liquidityFee","type":"uint256"}],"name":"setFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IMigrator","name":"_migrator","type":"address"}],"name":"setMigrator","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IERCBurn","name":"_referralToken","type":"address"},{"internalType":"uint256","name":"_hold","type":"uint256"}],"name":"setReferralTokenAndHold","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_secondaryFeeToken","type":"address"}],"name":"setSecondaryFeeToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"splitLock","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenLocks","outputs":[{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"initialAmount","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"},{"internalType":"uint256","name":"lockID","type":"uint256"},{"internalType":"address","name":"owner","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"address payable","name":"_newOwner","type":"address"}],"name":"transferLockOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapFactory","outputs":[{"internalType":"contract IUniFactory","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"bool","name":"_add","type":"bool"}],"name":"whitelistFeeAccount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}];

      mainContract = new web3.eth.Contract(mainABI, mainAdd);
      window.ethereum.request({ method: 'eth_requestAccounts' }).then(_accounts => {
        accounts = _accounts;
        finalAccount = accounts[0];
      }); 
    } 
  }

  const daysConvert = (date2) => {
    let date1 = new Date();
    let oned = 30 * 24 * 60 * 60 * 1000;
    return Math.ceil((date2 - date1) / oned);
  }
  const dateAlign = (widrawDate,userVal,lpAddress,indexVal,lockId,amount) => {
    let myDate = new Date(1000*widrawDate);
    if(daysConvert(myDate)<=1){
      if(daysConvert(myDate)<=0){
        return (
          <span>
            <a href="#" onClick={handleOpen} className='bg-warning QMD---withdrawBtn mr-3'> <LocalAtmIcon className='mr-2' />Relock</a>
            <a href="#" onClick={() => withdrawAmount(userVal,lpAddress,indexVal,lockId,amount)} className='QMD---withdrawBtn'> <LocalAtmIcon className='mr-2' />Withdraw</a>
          </span>
          );
      }else{
        return "in few days"
      }
    }else{
      return 'in ' + daysConvert(myDate)+' months'
    }
    // const today = Date.now();
  }
  const withdrawAmount = (user,lp,indexNo,lockId,amount) => {

    try{
      setLoader('block')
      mainContract.methods.withdraw(lp,indexNo,lockId,web3.utils.toBN(amount))
        .send({ from: finalAccount}).then( result => {
          setLoader('none');
          window.location.reload();
      })
      .catch(error => {
        setLoader('none')
        console.log('Error getting fake data 1234: ' , error);
      });
    } catch(error) {
      setLoader('none')
      console.log('Error getting fake data: ' , error);
    }

  }

  const reLockAmount = (user,lp,indexNo,lockId,newDate) => {
    if (useUnlockDate == "" || useUnlockDate == 0 || isNaN(useUnlockDate)){
      setdateError(true)
      return;
    }
    try{
      setLoader('block')
      mainContract.methods.relock(lp,indexNo,lockId,newDate)
        .send({ from: finalAccount }).then( result => {
          setLoader('none');
          window.location.reload();
      })
      .catch(error => {
        console.log('Error getting fake data 1234: ' , error);
        setLoader('none');
      });
    } catch(error) {
      console.log('Error getting fake data: ' , error);
      setLoader('none');
    }
  }
  const dateFormateForCard = (date2) => {
    let finaldate = new Date(1000*date2)
    // let finaldate = date2
    return finaldate.toLocaleString();
  }
  const financial = (num,digit,sint) => {
    if (sint == 'yes') {
      let val = num/1e18;
      return Number.parseFloat(val).toFixed(digit);
    }else{
      return Number.parseFloat(num).toFixed(digit);
    }
  }

 
  let hrefLink = "/lp-details?pair=" + props.name;
  return (
    <div className="w-100">
      <Loaders
        loaderDisplay = {useLoader}
      />
      <Grid 
        container 
        justify="space-between" 
        direction="row"
        xs={12}
        className="pb-2 mb-3"
        style={{borderBottom: '1px solid #16527c'}}
      >
        <div>
          <h4 className="mb-1 text-light">${financial(props.amount,2,'yes')} LP</h4>
          {/* <p className="mb-1 text-light"></p> */}
        </div>
        <div>
          <h4 className="mb-1 text-light text-right">{dateAlign(props.widrawDate, props.userVal, props.lpAddress, props.indexVal, props.lockId, props.amount)}</h4>
          <p className="mb-1 text-light text-right">{dateFormateForCard(props.widrawDate)}</p>
        </div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 className="text-center mb-3 text-light">Relocker</h2>
              <div className="lock--token py-4 px-4" style={{borderRadius: 5}}>
                <div  noValidate className="w-100">
                <h5 className="text-center text-light">Amount to be locked</h5>
                <h3 className="text-center text-light pb-3 mb-5" style={{borderBottom: '1px solid #161c3c'}}>{financial(props.amount,2,'yes')} LP</h3>
                  <p className="text-light">Select new date to unlock the LP tokens. </p>
                  <TextField className="clander--timer"
                      id="datetime-local"
                      label=""
                      type="datetime-local"
                      // defaultValue="2017-05-24T10:30"
                      className={classes.textField + ' w-100 QMF---inputLock'}
                      InputLabelProps={{
                      shrink: true,
                      }}
                      onChange={(event) =>handleDated(event)}
                  />
                  {usedateError ?
                      <div className="text-danger d-flex mt-1 mb-0 px-2 mx-auto w-100 text-left" role="alert">
                      <ErrorOutlineIcon className="mr-2" style={{color:'red',fontSize:18,marginTop: 2}}/>
                      <span className="d-inline-block">Select a Valid date and time for unlocking the LP Token.</span>
                      </div>
                  :
                      <p className="m-0" />
                  }
                  <div className="mt-4 text-right">
                    <a href="#" onClick={() => reLockAmount(props.userVal,props.lpAddress,props.indexVal,props.lockId,useUnlockDate)} className='QMD---withdrawBtn'> <LocalAtmIcon className='mr-2' />Confirm Relock</a>
                    <a href="#" onClick={handleClose} className='bg-danger QMD---withdrawBtn ml-3'> <CancelIcon className='mr-2' />Close</a>
                  </div>
                </div>
            </div>
            </div>
          </Fade>
        </Modal>
      </Grid>
    </div>
  );
}

export default WithDrawList;



